<template>
  <div>
    <!-- <div class="tittle">
            <div class="titletop flex">
                <div class="logo fl">
                    <img
                        src="../../assets/images/logoAll.png"
                        alt=""
                    />
                </div>
            </div>
        </div> -->
    <div class="loginBack" :style="{ height: parkHeight }">
      <div class="login_box">
        <h3>增材云业务管理后台</h3>
        <!-- 登录方式 -->
        <el-tabs class="loginClass" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="账号密码登录" name="first">
            <!-- 账户密码登录 -->
            <div>
              <div class="login_input">
                <div class="login_inputBox login_inputBox1">
                    <img src="../../assets/images/username.svg" alt="">
                    <input
                    type="text"
                    placeholder="请输入登录账号"
                    v-model="username"
                    />
                </div>
                <div class="login_inputBox">
                    <img src="../../assets/images/password.svg" alt="">
                    <input
                        type="password"
                        placeholder="请输入账号密码"
                        v-model="password"
                    />
                </div>

              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="loginChecked">
            <el-checkbox v-model="checked">自动登录</el-checkbox>
        </div>
        <div class="login_button">
          <button @click="getLogin()">登 录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserAndPassLogin } from "../../utils/interface";
import moment from "moment";
export default {
  name: "login",
  data() {
    return {
      parkHeight: "",
      username: "",
      password: "",
      loginIndex: "0",
      activeName: "first",
      checked: true,
    };
  },
  computed: {},
  created() {
    this.parkHeight = document.documentElement.clientHeight + "px";
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getLogin() {
      let params = {
        username: this.username,
        password: this.password,
      };
      // 手机用户名登录
      if (this.username == "" || this.password == "") {
        if (this.username == "") {
          this.$alert("请填写用户名", "提示", {
            confirmButtonText: "确定",
          });
        } else if (this.password == "") {
          this.$alert("请输入密码", "提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        getUserAndPassLogin(params)
          .then((res) => {
            if (res.access_token) {
              window.sessionStorage.removeItem("api_access_token");
              window.sessionStorage.setItem(
                "api_access_token",
                res.access_token
              );
              window.sessionStorage.setItem("api_token_new", res.access_token);
              window.sessionStorage.setItem("api_token_time",moment().format("YYYY-MM-DD HH:mm:ss"));
              // 成功后直接跳转
              this.$router.push("/home");
            } else {
              this.$alert(res.error, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}

.red {
  color: #d60000;
}

.loginBack {
  background: url("../../assets/images/loginBanner.svg") no-repeat;
  background-size: 100% 100%;
  position: relative;

  .login_box {
    // background: #fff;
    border-radius: 10px;
    width: 428px;
    position: absolute;
    left: 50%;
    top: 24px;
    transform: translate(-50%, 0);
    padding: 30px;
    h3 {
      margin: 0;
      text-align: center;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      font-size: 33px;
      margin-bottom: 40px;
    }
    .loginClass {
        /deep/.el-tabs__nav-wrap::after {
            background-color: transparent !important;
        }
        /deep/.el-tabs__nav {
            float: inherit !important;
            text-align: center
        }
        /deep/.el-tabs__active-bar {
            left: 38% !important;
        }
    }
    .login_input {
      width: 100%;
      margin-top: 3px;

      .login_inputBox {
          position: relative;
          img {
            position: absolute;
            top: 50%;
            left: 10px;
            transform: translate(0,-50%);
            width: 14px;
          }
      }
      .login_inputBox1 {
          margin-bottom: 24px;
      }
      input {
        border: 1px solid #d9d9d9;
        // border-radius: 10px;
        background: #fff;
        width: 100%;
        height: 40px;
        padding-left: 28px;
        font-size: 16px;
        color: #777;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        outline: none;
      }

      input:nth-child(1) {
        margin-bottom: 27px;
      }

      input::-webkit-input-placeholder {
        color: #b3b3b3;
      }
    }
    .loginChecked {
        margin-top: 24px;
    }
    .login_button {
      width: 100%;
      margin: 24px 0 20px;

      button {
        border: none;
        background: #1181ff;
        width: 100%;
        height: 40px;
        color: #fff;
        // font-weight: bold;
        font-size: 18px;
        // border-radius: 10px;
      }
    }
  }
}

.tittle {
  position: fixed;
  background: #fff;
  box-shadow: 0 -1px 0 #f0f0f0 inset;
  width: 100%;
  height: 80px;
  z-index: 9999;

  .logo {
    // margin: 19px 42px 0 38px;
    align-items: center;
    display: flex;
    // flex: 1;
    img {
      height: 50px;
      margin: 8px 0 0 0;
      padding: 0;
    }
  }

  .titletop {
    width: 1200px;
    align-items: center;
    margin: 0 auto;
  }
}

.login {
  justify-content: center;
  align-items: center;
  // flex: 1;
  .lh90 {
    cursor: pointer;
    font-size: 15px;
  }

  .lh90:nth-last-child(1) {
    margin-left: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue